/**
 * ESC @ (initialize). The renderers emit no reset of their own, so a receipt
 * otherwise inherits whatever character size, reverse video, alignment or line
 * spacing the previous job left set. A Bluetooth printer powers up clean, but
 * Sunmi's built-in printer is shared with the rest of the device and is
 * routinely left in another app's state — printing large white-on-black text.
 */
const ESC_POS_INITIALIZE = [0x1b, 0x40];

/**
 * Inverse of the `String.fromCharCode` packing in `renderDocumentToEscPos` —
 * every char code is a single 0–255 byte — behind a leading printer reset.
 */
export function escPosCommandsToDeviceBytes(commands: string[]): Uint8Array {
  const joined = commands.join("");
  const bytes = new Uint8Array(ESC_POS_INITIALIZE.length + joined.length);

  bytes.set(ESC_POS_INITIALIZE);
  for (let i = 0; i < joined.length; i++) {
    bytes[ESC_POS_INITIALIZE.length + i] = joined.charCodeAt(i) & 0xff;
  }

  return bytes;
}
